import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as Common from '_common';
import * as Utils from '_utils';
import * as Styles from './Process.module.scss';
export function RenderProcess(component, index) {
    return (_jsx(ProcessComponent, { id: component.properties.id }, index));
}
var ActivityState = /** @class */ (function () {
    function ActivityState() {
    }
    ActivityState.Pending = "Pending";
    ActivityState.InProgress = "InProgress";
    ActivityState.Completed = "Completed";
    ActivityState.Failed = "Failed";
    ActivityState.Cancelled = "Cancelled";
    return ActivityState;
}());
export { ActivityState };
export function ProcessComponent(props) {
    var context = Common.useSpaContext();
    var processes = context === null || context === void 0 ? void 0 : context.process;
    var processInfo = JSON.parse(processes[props.id]);
    if (!processInfo) {
        return _jsx("div", { children: "Process not found" });
    }
    return _jsx(ProcessDisplay, { process: processInfo });
}
export function ProcessDisplay(props) {
    return (_jsx("ul", { className: Styles.process, children: props.process.tasks.map(function (activity, index) { return (_jsx(Activity, { activity: activity }, index)); }) }));
}
export function Activity(props) {
    var _a;
    var _b;
    var classes = Utils.classNames((_a = {},
        _a[Styles.activity] = true,
        _a[Styles.pending] = props.activity.state === ActivityState.Pending,
        _a[Styles.running] = props.activity.state === ActivityState.InProgress,
        _a[Styles.completed] = props.activity.state === ActivityState.Completed,
        _a[Styles.cancelled] = props.activity.state === ActivityState.Cancelled,
        _a[Styles.failed] = props.activity.state === ActivityState.Failed,
        _a));
    var progress = _jsx(_Fragment, {});
    if (props.activity.progress > 0) {
        progress = (_jsx("progress", { value: props.activity.progress, max: 100, children: (_b = props.activity.progressString) !== null && _b !== void 0 ? _b : props.activity.progress + '%' }));
    }
    return (_jsxs("li", { className: classes, children: [props.activity.name, " - ", props.activity.state, progress] }));
}
